module.exports = __webpack_public_path__ + "img/section2-1.03004217.png";